import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<ClassGroupVtycPointsCard @event={{@model}}/>",{ moduleName: "bullitt-time-results/templates/event/vtyc/points.hbs" })